import Button, {ButtonSize, ButtonVariant} from "@components/Button";
import SectionHeader from "@components/Footer/SectionHeader";
import {SectionLink} from "@components/Footer/SectionLink";
import {useTranslation} from "ni18n";
import React from "react";

import {v5Pages} from "../../../components/_common/_constants";
import useMediaQuery from "../../../useMediaQuery";
import {Care, RelatedTopic} from "../../../utils/cms/types";

type Props = {
  relatedTo?: Care[] | RelatedTopic[];
  condition: string;
};

export const RelatedLinks = ({condition, relatedTo}: React.PropsWithChildren<Props>) => {
  const i18n = useTranslation();

  return (
    <section className="max-w-7xl mx-auto px-8 mt-8">
      <h2>{i18n.t("Similar reasons to {{condition}}", {condition})}</h2>
      <div className="flex flex-row flex-wrap justify-between mt-6 gap-y-6">
        {relatedTo?.length ? <RelatedReasonsSection relatedTo={relatedTo} /> : null}
        <MoreServicesSection />
      </div>
    </section>
  );
};

type RelatedReasonsSectionProps = {
  relatedTo: Care[] | RelatedTopic[];
};

const RelatedReasonsSection = ({relatedTo}: RelatedReasonsSectionProps) => {
  const i18n = useTranslation();

  const xsButtons = useMediaQuery("sm");

  return (
    <section className="min-w-[24.25rem] w-1/2">
      <SectionHeader text={i18n.t("SIMILAR REASONS")} />
      <ul className="flex flex-row flex-wrap gap-x-2 gap-y-3 mt-3">
        {relatedTo.map(relation => (
          <li key={relation.name}>
            <Button
              size={xsButtons ? ButtonSize.XS : ButtonSize.SM}
              variant={ButtonVariant.GHOST}
              href={relation.slug}
            >
              {relation.name}
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
};

const MoreServicesSection = () => {
  const i18n = useTranslation();
  return (
    <section>
      <SectionHeader text={i18n.t("MORE SERVICES")} />
      <ul className="grid grid-cols-[11.25rem_10rem] gap-y-6 gap-x-12 mt-8">
        <SectionLink text={i18n.t("Urgent Care")} href={v5Pages.urgentCare} />
        <SectionLink text={i18n.t("Labs & Lab Results")} href={v5Pages.labsAndLabResults} />
        <SectionLink text={i18n.t("Primary Care")} href={v5Pages.primaryCare} />
        <SectionLink text={i18n.t("Pediatrics")} href={v5Pages.pediatrics} />
        <SectionLink text={i18n.t("Mental Health")} href={v5Pages.mentalHealth} />
        <SectionLink text={i18n.t("COVID Vaccination")} href={v5Pages.covid19Vaccination} />
        <SectionLink text={i18n.t("Workplace Health")} href={v5Pages.workplaceHealth} />
        <SectionLink text={i18n.t("COVID Testing")} href={v5Pages.covid19Testing} />
        <SectionLink text={i18n.t("Imaging")} href={v5Pages.imaging} />
        <SectionLink text={i18n.t("COVID Positive Care")} href={v5Pages.covidTreatment} />
      </ul>
    </section>
  );
};
